module.exports = __webpack_public_path__ + "static/img/travel1.ac013a12.png";